const PASSWORD_MIN_LENGTH = 8

export const STRINGS = {
  PASSWORD_MIN_LENGTH,
}
